module.exports = __webpack_public_path__ + "img/breastcancer_whiteshirt_0.b2e70155.jpg";